import { IKnoCollaborating } from 'APIPackage/KnmModule/interfaces/IKnoCollaborating';
import { IKnmErknmFormCollaboratingOrganization } from 'KnmPackage/MainModule/interfaces/IKnmErknmFormCollaboratingOrganization';

export const convertCollaboratingOrganizationsFormValueToKnmData = (
  collaboratingOrganizations: IKnmErknmFormCollaboratingOrganization[] | undefined,
): IKnoCollaborating[] | null => {
  if (!collaboratingOrganizations) {
    return null;
  }

  return collaboratingOrganizations.map(item => {
    const data: IKnoCollaborating = {
      organization: item.organization?.value || null,
      guid: item.guid || null,
      dateCreate: item.dateCreate || null,
      title: item.title || null,
      ervkKnoOrganizationId: item.ervkKnoOrganizationId || null,
      ervkTerritoryAgencyId: item.ervkTerritoryAgencyId || null,
      ervkTerritoryAgencyVersionId: item.ervkTerritoryAgencyVersionId || null,
    };

    return data;
  });
};
